import React, { useEffect, useRef, useState, useCallback } from 'react';
import problem1 from '../images/problem1.png';
import problem2 from '../images/problem2.png';
import problem3 from '../images/problem3.png';
import solution1 from '../images/solution1.png';
import solution2 from '../images/solution2.png';
import solution3 from '../images/solution3.png';
import solution4 from '../images/solution4.png';
import solution5 from '../images/solution5.png';
import solution6 from '../images/solution6.png';
import solution7 from '../images/solution7.png';
import doc1 from '../images/doc1.png';
import doc2 from '../images/doc2.png';
import doc3 from '../images/doc3.png';
import doc4 from '../images/doc4.png';
import sale from '../images/sale.png';
// Hero 이미지들 import
import variant1 from '../images/Variant 1.png';
import hero3 from '../images/hero3.png';
import {
  Container,
  Highlight,
  HighlightOrange,
  HighlightVision,
  HighlightCost,
  HeroButtons,
  PrimaryButton,
  ProblemSection,
  ProblemContainer,
  ProblemHeader,
  Badge,
  ProblemGrid,
  ProblemItem,
  SolutionSection,
  SolutionHeader,
  YellowBadge,
  SolutionContent,
  SolutionItem,
  Solution2Section,
  Solution2Header,
  Solution2Content,
  Solution2Item,
  Solution3Section,
  Solution3Header,
  Solution3Content,
  Solution3Left,
  Solution3Right,
  BenefitsSection,
  BenefitsHeader,
  BenefitsGrid,
  BenefitItem,
  CertificationSection,
  CertificationHeader,
  CertificationCarouselWrapper,
  CertificationCarousel,
  PromotionSection,
  PromotionContent,
  PromotionLeft,
  PromotionRight,
  MediaSection,
  MediaContent,
  MediaText,
  FinalCTASection,
  FinalCTAContent,
  FinalCTALeft,
  FinalCTARight,
  NewHeroSection,
  HeroImageGrid,
  HeroImageItem,
  NewHeroContent,
  RoadAnimationContainer,
  MovingVehicle
} from './Home.styled';
import { ContactModal } from '../components/ContactModal';
import { N8N_WEBHOOK_URL } from '../config';

interface SectionAnimationTrigger {
  section: string;
  startProgress: number;
  endProgress: number;
  hasTriggered: boolean;
}

const Home: React.FC = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const problemWrapperRef = useRef<HTMLDivElement>(null);
  const problemSectionRef = useRef<HTMLElement>(null);
  const solutionSectionRef = useRef<HTMLElement>(null);
  const solution2SectionRef = useRef<HTMLElement>(null);
  const solution3SectionRef = useRef<HTMLElement>(null);
  const benefitsSectionRef = useRef<HTMLElement>(null);
  const certificationSectionRef = useRef<HTMLElement>(null);
  const promotionSectionRef = useRef<HTMLElement>(null);
  const mediaSectionRef = useRef<HTMLElement>(null);
  const finalCTASectionRef = useRef<HTMLElement>(null);

  const [, setScrollProgress] = useState(0);
  const [animationTriggers, setAnimationTriggers] = useState<SectionAnimationTrigger[]>([]);

  // 화면 크기에 따른 트리거 포인트 설정
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    
    // 데스크톱: 기존 통합 방식 유지
    const desktopTriggers: SectionAnimationTrigger[] = [
      { section: 'problem', startProgress: 0.07, endProgress: 0.25, hasTriggered: false },
      { section: 'solution1', startProgress: 0.27, endProgress: 0.35, hasTriggered: false },
      { section: 'solution2', startProgress: 0.45, endProgress: 0.55, hasTriggered: false },
      { section: 'solution3', startProgress: 0.57, endProgress: 0.62, hasTriggered: false },
      { section: 'benefits', startProgress: 0.65, endProgress: 0.75, hasTriggered: false },
      { section: 'certification', startProgress: 0.73, endProgress: 0.82, hasTriggered: false },
      { section: 'promotion', startProgress: 0.82, endProgress: 0.92, hasTriggered: false },
      { section: 'media', startProgress: 0.91, endProgress: 0.96, hasTriggered: false },
      { section: 'finalCTA', startProgress: 0.97, endProgress: 1.0, hasTriggered: false }
    ];

    // 모바일: 요청하신 세부 수치 적용
    const mobileTriggers: SectionAnimationTrigger[] = [
      { section: 'problem_header', startProgress: 0.045, endProgress: 0.10, hasTriggered: false },
      { section: 'problem_item_1', startProgress: 0.07, endProgress: 0.15, hasTriggered: false },
      { section: 'problem_item_2', startProgress: 0.10, endProgress: 0.20, hasTriggered: false },
      { section: 'problem_item_3', startProgress: 0.13, endProgress: 0.25, hasTriggered: false },
      { section: 'solution1_header', startProgress: 0.23, endProgress: 0.30, hasTriggered: false },
      { section: 'solution1_item_1', startProgress: 0.25, endProgress: 0.35, hasTriggered: false },
      { section: 'solution1_item_2', startProgress: 0.29, endProgress: 0.40, hasTriggered: false },
      { section: 'solution1_item_3', startProgress: 0.35, endProgress: 0.45, hasTriggered: false },
      { section: 'solution2_header', startProgress: 0.41, endProgress: 0.50, hasTriggered: false },
      { section: 'solution2_item_1', startProgress: 0.44, endProgress: 0.55, hasTriggered: false },
      { section: 'solution2_item_2', startProgress: 0.48, endProgress: 0.60, hasTriggered: false },
      { section: 'solution2_item_3', startProgress: 0.54, endProgress: 0.65, hasTriggered: false },
      { section: 'solution3', startProgress: 0.57, endProgress: 0.62, hasTriggered: false },
      { section: 'benefits', startProgress: 0.65, endProgress: 0.75, hasTriggered: false },
      { section: 'certification', startProgress: 0.73, endProgress: 0.82, hasTriggered: false },
      { section: 'promotion', startProgress: 0.82, endProgress: 0.92, hasTriggered: false },
      { section: 'media', startProgress: 0.87, endProgress: 0.96, hasTriggered: false },
      { section: 'finalCTA', startProgress: 0.91, endProgress: 1.0, hasTriggered: false }
    ];

    setAnimationTriggers(isMobile ? mobileTriggers : desktopTriggers);
  }, []);

  // 각 섹션별 애니메이션 함수들
  const animateProblemHeader = () => {
    if (!problemSectionRef.current) return;
    const problemHeader = problemSectionRef.current.querySelector('.problem-header') as HTMLElement;
    
    if (problemHeader) {
      problemHeader.classList.add('animate');
      problemHeader.style.cssText = 'opacity: 1 !important; transform: translateY(0) !important;';
    }
  };

  const animateProblemItem = (index: number) => {
    if (!problemSectionRef.current) return;
    const problemItems = problemSectionRef.current.querySelectorAll('.problem-item');
    if (problemItems[index]) {
      (problemItems[index] as HTMLElement).classList.add('animate');
    }
  };

  const animateSolution1Header = () => {
    if (!solutionSectionRef.current) return;
    const solutionHeader = solutionSectionRef.current.querySelector('.solution-header') as HTMLElement;
    if (solutionHeader) {
      solutionHeader.classList.add('animate');
    }
  };

  const animateSolution1Item = (index: number) => {
    if (!solutionSectionRef.current) return;
    const solutionItems = solutionSectionRef.current.querySelectorAll('.solution-item');
    if (solutionItems[index]) {
      const element = solutionItems[index] as HTMLElement;
      element.style.opacity = '1';
      element.style.transform = 'translateY(0)';
    }
  };

  const animateSolution2Header = () => {
    if (!solution2SectionRef.current) return;
    const solution2Header = solution2SectionRef.current.querySelector('.solution2-header') as HTMLElement;
    if (solution2Header) {
      solution2Header.classList.add('animate');
    }
  };

  const animateSolution2Item = (index: number) => {
    if (!solution2SectionRef.current) return;
    const solution2Items = solution2SectionRef.current.querySelectorAll('.solution2-item');
    if (solution2Items[index]) {
      const element = solution2Items[index] as HTMLElement;
      element.style.opacity = '1';
      element.style.transform = 'translateX(0)';
    }
  };

  const animateSolution3Section = () => {
    if (!solution3SectionRef.current) return;
    
    // styled-components로 생성된 요소들을 직접 찾기
    const allDivs = solution3SectionRef.current.querySelectorAll('div');
    let solution3Header: HTMLElement | null = null;
    let solution3Left: HTMLElement | null = null;
    let solution3Right: HTMLElement | null = null;
    
    // Solution3Header, Solution3Left, Solution3Right 컴포넌트 찾기
    for (const div of allDivs) {
      if (div.querySelector('h2') && div.querySelector('h2')?.textContent?.includes('사업장을 더욱 환하게')) {
        solution3Header = div as HTMLElement;
      }
      if (div.classList.contains('solution3-left') || div.querySelector('.solution3-image')) {
        solution3Left = div as HTMLElement;
      }
      if (div.classList.contains('solution3-right') || (div.querySelector('h3') && div.querySelector('h3')?.textContent?.includes('깔끔하고 청결한'))) {
        solution3Right = div as HTMLElement;
      }
    }
    
    // 좌우 컨텐츠만 초기 상태 설정 (헤더는 CSS에서 이미 opacity: 0)
    if (solution3Left) {
      solution3Left.style.opacity = '0';
      solution3Left.style.transform = 'translateY(50px)';
      solution3Left.style.transition = 'all 0.8s ease';
    }
    
    if (solution3Right) {
      solution3Right.style.opacity = '0';
      solution3Right.style.transform = 'translateY(50px)';
      solution3Right.style.transition = 'all 0.8s ease';
    }
    
    // 1단계: 타이틀 먼저 아래에서 위로 나타남
    setTimeout(() => {
      if (solution3Header) {
        solution3Header.classList.add('animate');
        
        // 강제로 스타일 적용 (Problem처럼)
        solution3Header.style.cssText = 'opacity: 1 !important; transform: translateY(0) !important;';
      }
    }, 200);
    
    // 2단계: 사진과 글이 동시에 아래에서 위로 나타남 (타이틀 애니메이션 후)
    setTimeout(() => {
      if (solution3Left) {
        solution3Left.style.opacity = '1';
        solution3Left.style.transform = 'translateY(0)';
      }
      
      if (solution3Right) {
        solution3Right.style.opacity = '1';
        solution3Right.style.transform = 'translateY(0)';
      }
    }, 800); // 타이틀 애니메이션 완료 후 600ms 뒤에 시작
  };

  const animateBenefitsSection = () => {
    if (!benefitsSectionRef.current) return;
    
    // Benefits 헤더와 아이템들 찾기
    const benefitsHeader = benefitsSectionRef.current.querySelector('.benefits-header') as HTMLElement;
    const benefitItems = benefitsSectionRef.current.querySelectorAll('.benefit-item');
    
    // 1단계: 헤더 먼저 아래에서 위로 나타남
    setTimeout(() => {
      if (benefitsHeader) {
        benefitsHeader.classList.add('animate');
      }
    }, 200);
    
    // 2단계: Benefit 아이템들이 순차적으로 나타남
    setTimeout(() => {
      benefitItems.forEach((item, index) => {
        const element = item as HTMLElement;
        
        setTimeout(() => {
          element.classList.add('animate');
        }, index * 200); // 200ms 간격으로 순차 애니메이션
      });
    }, 600); // 헤더 애니메이션 완료 후
  };

  const animateCertificationSection = () => {
    if (!certificationSectionRef.current) return;
    
    // Certification 헤더 찾기
    const certificationHeader = certificationSectionRef.current.querySelector('.certification-header') as HTMLElement;
    
    // 헤더 아래에서 위로 나타남
    setTimeout(() => {
      if (certificationHeader) {
        certificationHeader.classList.add('animate');
      }
    }, 200);
  };

  const animatePromotionSection = () => {
    if (!promotionSectionRef.current) return;
    
    // Promotion 요소들 찾기
    const promotionLeft = promotionSectionRef.current.querySelector('.promotion-left') as HTMLElement;
    const promotionRight = promotionSectionRef.current.querySelector('.promotion-right') as HTMLElement;
    
    // 타이틀과 이미지 동시에 아래에서 위로 나타남
    setTimeout(() => {
      if (promotionLeft) {
        promotionLeft.classList.add('animate');
      }
      if (promotionRight) {
        promotionRight.classList.add('animate');
      }
    }, 200);
  };

  const animateMediaSection = () => {
    if (!mediaSectionRef.current) return;
    
    // Media 텍스트 찾기
    const mediaText = mediaSectionRef.current.querySelector('.media-text') as HTMLElement;
    
    // 텍스트 아래에서 위로 나타남
    setTimeout(() => {
      if (mediaText) {
        mediaText.classList.add('animate');
      }
    }, 200);
  };

  const animateFinalCTASection = () => {
    if (!finalCTASectionRef.current) return;
    
    // Final CTA 요소 찾기
    const finalCTALeft = finalCTASectionRef.current.querySelector('.final-cta-left') as HTMLElement;
    
    // 타이틀과 글 아래에서 위로 나타남
    setTimeout(() => {
      if (finalCTALeft) {
        finalCTALeft.classList.add('animate');
      }
    }, 200);
  };

  // 모든 애니메이션 상태 및 스타일 초기화
  const resetAllAnimations = useCallback(() => {
    animationTriggers.forEach(trigger => {
      trigger.hasTriggered = false;
    });

    const sections = [
      problemSectionRef, solutionSectionRef, solution2SectionRef, 
      solution3SectionRef, benefitsSectionRef, certificationSectionRef, 
      promotionSectionRef, mediaSectionRef, finalCTASectionRef
    ];

    sections.forEach(ref => {
      if (ref.current) {
        const animatedElements = ref.current.querySelectorAll('.animate');
        animatedElements.forEach(el => {
          el.classList.remove('animate');
          (el as HTMLElement).style.cssText = '';
        });

        const items = ref.current.querySelectorAll('.problem-item, .solution-item, .solution2-item, .benefit-item');
        items.forEach(el => {
          (el as HTMLElement).style.opacity = '';
          (el as HTMLElement).style.transform = '';
          (el as HTMLElement).style.transition = '';
        });
      }
    });
  }, [animationTriggers]);

  // 섹션별 애니메이션 트리거 함수
  const triggerSectionAnimation = useCallback((section: string) => {
    switch (section) {
      case 'problem':
        animateProblemHeader();
        setTimeout(() => animateProblemItem(0), 300);
        setTimeout(() => animateProblemItem(1), 600);
        setTimeout(() => animateProblemItem(2), 900);
        break;
      case 'problem_header':
        animateProblemHeader();
        break;
      case 'problem_item_1':
        animateProblemItem(0);
        break;
      case 'problem_item_2':
        animateProblemItem(1);
        break;
      case 'problem_item_3':
        animateProblemItem(2);
        break;
      case 'solution1':
        animateSolution1Header();
        setTimeout(() => animateSolution1Item(0), 300);
        setTimeout(() => animateSolution1Item(1), 600);
        setTimeout(() => animateSolution1Item(2), 900);
        break;
      case 'solution1_header':
        animateSolution1Header();
        break;
      case 'solution1_item_1':
        animateSolution1Item(0);
        break;
      case 'solution1_item_2':
        animateSolution1Item(1);
        break;
      case 'solution1_item_3':
        animateSolution1Item(2);
        break;
      case 'solution2':
        animateSolution2Header();
        setTimeout(() => animateSolution2Item(0), 300);
        setTimeout(() => animateSolution2Item(1), 600);
        setTimeout(() => animateSolution2Item(2), 900);
        break;
      case 'solution2_header':
        animateSolution2Header();
        break;
      case 'solution2_item_1':
        animateSolution2Item(0);
        break;
      case 'solution2_item_2':
        animateSolution2Item(1);
        break;
      case 'solution2_item_3':
        animateSolution2Item(2);
        break;
      case 'solution3':
        animateSolution3Section();
        break;
      case 'benefits':
        animateBenefitsSection();
        break;
      case 'certification':
        animateCertificationSection();
        break;
      case 'promotion':
        animatePromotionSection();
        break;
      case 'media':
        animateMediaSection();
        break;
      case 'finalCTA':
        animateFinalCTASection();
        break;
      default:
        break;
    }
  }, []);

  const handleProblemScroll = useCallback(() => {
    if (!problemSectionRef.current || !problemWrapperRef.current) return;
    
    const sectionRect = problemSectionRef.current.getBoundingClientRect();
    const sectionTop = sectionRect.top;
    const containerHeight = problemSectionRef.current.querySelector('.problem-container')?.clientHeight || 0;
    
    if (sectionTop <= 0 && sectionTop > -(sectionRect.height - containerHeight)) {
      const scrollProgress = -sectionTop;
      problemWrapperRef.current.style.transform = `translateY(-${scrollProgress}px)`;
    }
  }, []);

  // 전체 스크롤 진행도 계산
  const calculateScrollProgress = useCallback(() => {
    const scrollTop = window.pageYOffset;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = scrollTop / docHeight;
    return Math.min(Math.max(progress, 0), 1);
  }, []);

  // 스크롤 핸들러
  const handleScroll = useCallback(() => {
    const progress = calculateScrollProgress();
    setScrollProgress(progress);
    
    // 최상단으로 돌아왔을 때 모든 애니메이션 초기화
    if (progress === 0) {
      resetAllAnimations();
    }

    // 각 섹션의 애니메이션 트리거 체크
    animationTriggers.forEach(trigger => {
      if (!trigger.hasTriggered && 
          progress >= trigger.startProgress && 
          progress <= trigger.endProgress) {
        trigger.hasTriggered = true;
        triggerSectionAnimation(trigger.section);
      }
    });

    // Problem 섹션의 스크롤 애니메이션
    handleProblemScroll();
  }, [animationTriggers, calculateScrollProgress, resetAllAnimations, triggerSectionAnimation, handleProblemScroll]);

  // 스크롤 이벤트 리스너 등록 및 해제
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const button = form.querySelector('.submit-btn') as HTMLButtonElement;
    const originalText = button.textContent || '';
    
    // Form data extraction
    const formData = new FormData(form);
    const payload = {
      source: 'bottom_section_cta',
      name: formData.get('name'),
      company: formData.get('company'),
      phone: formData.get('phone'),
      email: formData.get('email'),
      title: formData.get('title'),
      message: formData.get('message'),
    };

    button.textContent = '전송 중...';
    button.disabled = true;

    try {
      await fetch(N8N_WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      
      button.textContent = '전송 완료!';
      button.style.background = '#4ade80';
      form.reset();
    } catch (error) {
      console.error('Submission failed', error);
      button.textContent = '전송 실패';
      button.style.background = '#ff4d4f';
    } finally {
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
        button.style.background = '';
      }, 3000);
    }
  };

  return (
    <main>

      <NewHeroSection>
        <HeroImageGrid>
          <HeroImageItem>
            <img src={variant1} alt="Variant 1" />
          </HeroImageItem>
        </HeroImageGrid>
        <RoadAnimationContainer>
          <MovingVehicle>
            <img src={hero3} alt="Moving Vehicle" />
          </MovingVehicle>
        </RoadAnimationContainer>
        <Container>
          <NewHeroContent>
            <h1>
              <HighlightOrange>매일 찾아오는</HighlightOrange> <Highlight>청결함</Highlight>
            </h1>
            <p>'쓸모'로 매일 음식물쓰레기를 쓸모 있게 만드세요!</p>
            <HeroButtons>
              <PrimaryButton href="#" onClick={(e) => { e.preventDefault(); localStorage.setItem('cta_source', 'hero_top_cta'); setIsContactOpen(true); }}>도입 문의하기</PrimaryButton>
              <PrimaryButton href="/서비스 소개서.pdf" target="_blank" rel="noopener noreferrer">서비스 소개서</PrimaryButton>
            </HeroButtons>
          </NewHeroContent>
        </Container>
      </NewHeroSection>

      <ProblemSection ref={problemSectionRef}>
        <ProblemContainer className="problem-container">
          <ProblemHeader className="problem-header">
            <Badge>PROBLEM</Badge>
            <h2><HighlightOrange>식품 폐기물 수거</HighlightOrange>,<br />어려운 점 없으셨나요?</h2>
          </ProblemHeader>
          
          <ProblemGrid ref={problemWrapperRef}>
            <ProblemItem className="problem-item">
              <div className="problem-image">
                <img src={problem1} alt="아직도 주 2회 수거하시나요?" loading="lazy" />
              </div>
              <div className="problem-content">
                <h3>아직도 주 2회 수거하시나요?</h3>
                <p>매일 나오는 식품 폐기물, 배출일이 일정하지 않거나 급하게 처리해야 할 때는 
                어떻게 하고 계신가요?</p>
              </div>
            </ProblemItem>
            
            <ProblemItem className="problem-item">
              <div className="problem-image">
                <img src={problem2} alt="부정확한 배출량 측정" loading="lazy" />
              </div>
              <div className="problem-content">
                <h3>부정확한 배출량 측정, 불투명한 과금 시스템</h3>
                <p>한 달 식품 폐기물 처리 비용, 정확히 얼마인지 알고 계신가요?</p>
              </div>
            </ProblemItem>
            
            <ProblemItem className="problem-item">
              <div className="problem-image">
                <img src={problem3} alt="더러운 수거함" loading="lazy" />
              </div>
              <div className="problem-content">
                <h3>더러운 수거용기,<br />사업장 이미지에 영향이 없을까요?</h3>
                <p>청결한 사업장이 신뢰를 만든다는 사실, 혹시 간과하고 계신 건 아닐까요?</p>
              </div>
            </ProblemItem>
          </ProblemGrid>
        </ProblemContainer>
      </ProblemSection>

      <SolutionSection ref={solutionSectionRef} className="SolutionSection">
        <Container>
          <SolutionHeader className="solution-header">
            <YellowBadge>SOLUTION 1</YellowBadge>
            <h2>이제는 매일 찾아오는<br />수거 서비스, <HighlightCost>쓸모</HighlightCost></h2>
          </SolutionHeader>
          
          <SolutionContent>
            <SolutionItem className="solution-item">
              <div className="item-image">
                <img src={solution2} alt="정확한 수거 일정" loading="lazy" />
              </div>
              <div className="item-content">
                <h3>정확한 수거 일정</h3>
                <p>쓸모는 정확한 수거 일정을 제공해 식품 폐기물이 쌓이지 않도록 도와주며 불쾌한 냄새와 위생 문제를 예방합니다.</p>
              </div>
            </SolutionItem>
            
            <SolutionItem className="solution-item">
              <div className="item-image">
                <img src={solution1} alt="최적의 수거 주기" loading="lazy" />
              </div>
              <div className="item-content">
                <h3>최적의 수거 주기</h3>
                <p>쓸모는 최적의 수거 주기를 제공하여 고객의 식품 폐기물을 처리해야 하는 불편을 최소화 합니다. 더 이상 쌓아두지 않고도 깨끗하고 위생적인 사업장 환경을 유지할 수 있어요.</p>
              </div>
            </SolutionItem>
            
            <SolutionItem className="solution-item">
              <div className="item-image">
                <img src={solution3} alt="즉각적인 추가 수거" loading="lazy" />
              </div>
              <div className="item-content">
                <h3>즉각적인 추가 수거</h3>
                <p>사업장이 환상 청결하고 깔끔한 상태를 유지할 수 있도록 도와드리며 급한 상황에서도 즉각적인 추가 수거 요청이 가능합니다.</p>
              </div>
            </SolutionItem>
          </SolutionContent>
        </Container>
      </SolutionSection>

      <Solution2Section ref={solution2SectionRef}>
        <Container>
          <Solution2Header className="solution2-header">
            <YellowBadge>SOLUTION 2</YellowBadge>
            <h2><HighlightVision>AI</HighlightVision>를 통해<br /><HighlightCost>더욱 정확해진 비용 측정</HighlightCost></h2>
          </Solution2Header>
          
          <Solution2Content>
            <Solution2Item className="solution2-item">
              <div className="item-image">
                <img src={solution4} alt="정확한 배출량 측정" loading="lazy" />
              </div>
              <div className="item-content">
                <h3>정확한 배출량 측정</h3>
                <p>AI 기반 시스템을 사용하여 매일 배출된 양을 정확히 기록하고 이에 맞는 요금을 부과합니다.</p>
              </div>
            </Solution2Item>
            
            <Solution2Item className="solution2-item">
              <div className="item-image">
                <img src={solution5} alt="비용 절감 효과" loading="lazy" />
              </div>
              <div className="item-content">
                <h3>비용 절감 효과</h3>
                <p>쓸모의 시스템은 고객이 과도한 비용을 지불하는 문제를 해결하며, 비용 절감에도 도움을 줍니다.</p>
              </div>
            </Solution2Item>
            
            <Solution2Item className="solution2-item">
              <div className="item-image">
                <img src={solution6} alt="투명한 과금 기준" loading="lazy" />
              </div>
              <div className="item-content">
                <h3>투명한 과금 기준</h3>
                <p>실시간으로 배출량을 확인하고, 요금이 정확히 어떤 기준으로 책정되었는지 알 수 있습니다.</p>
              </div>
            </Solution2Item>
          </Solution2Content>
        </Container>
      </Solution2Section>

      <Solution3Section ref={solution3SectionRef}>
        <Container>
          <Solution3Header>
            <YellowBadge>SOLUTION 3</YellowBadge>
            <h2>사업장을 더욱 환하게 할<br /><HighlightCost>청결하고 위생적인</HighlightCost> <HighlightVision>수거용기</HighlightVision></h2>
          </Solution3Header>
          
          <Solution3Content>
            <Solution3Left className="solution3-left">
              <div className="solution3-image">
                <img src={solution7} alt="깨끗하고 청결한 수거용기" loading="lazy" />
              </div>
            </Solution3Left>
            
            <Solution3Right className="solution3-right">
              <h3>깔끔하고 청결한 수거용기 제공</h3>
              <p>청결하고 위생적인 수거용기를 제공하여, 고객이 비즈니스 환경에서 이미지 손상을 걱정하지 않도록 합니다. 고객에게 깔끔하고 정결한 수거 시스템을 제공하여 사업장의 이미지 개선을 돕습니다.</p>
            </Solution3Right>
          </Solution3Content>
        </Container>
      </Solution3Section>

      <BenefitsSection ref={benefitsSectionRef}>
        <Container>
          <BenefitsHeader className="benefits-header">
            <h2><HighlightCost>쓸모</HighlightCost>를 이용하면서 얻게 될<br /><Highlight>놀라운 효과</Highlight>를 경험하세요!</h2>
          </BenefitsHeader>
          
          <BenefitsGrid>
            <BenefitItem className="benefit-item">
              <div className="benefit-number">2x</div>
              <div className="benefit-description">타 서비스 대비 2배 이상 수거 방문</div>
            </BenefitItem>
            
            <BenefitItem className="benefit-item">
              <div className="benefit-number">20%</div>
              <div className="benefit-description">기존 대비 20% 이상 비용 절감</div>
            </BenefitItem>
            
            <BenefitItem className="benefit-item">
              <div className="benefit-number">24/7</div>
              <div className="benefit-description">긴급센터에서 당일 긴급 수거 부재 가능</div>
            </BenefitItem>
          </BenefitsGrid>
        </Container>
      </BenefitsSection>

      <CertificationSection ref={certificationSectionRef}>
        <Container>
          <CertificationHeader className="certification-header">
            <h2>공신력 있는 기관에서<br />인증 받은 <HighlightVision>안전한 서비스</HighlightVision>, <HighlightCost>쓸모</HighlightCost></h2>
          </CertificationHeader>
        </Container>
        
        <CertificationCarouselWrapper>
          <CertificationCarousel className="certification-carousel">
            <div className="certification-track">
              {[1, 2, 3].map(setNum => (
                <React.Fragment key={setNum}>
                  <div className="certification-item">
                    <img src={doc1} alt="기업부설연구소 인정서" />
                  </div>
                  <div className="certification-item">
                    <img src={doc2} alt="글로벌 환경경영시스템인증서" />
                  </div>
                  <div className="certification-item">
                    <img src={doc3} alt="환경경영시스템인증서" />
                  </div>
                  <div className="certification-item">
                    <img src={doc4} alt="벤처기업확인서" />
                  </div>
                </React.Fragment>
              ))}
            </div>
          </CertificationCarousel>
        </CertificationCarouselWrapper>
      </CertificationSection>

      <PromotionSection ref={promotionSectionRef}>
        <Container>
          <PromotionContent>
            <PromotionLeft className="promotion-left">
              <h2>비용이 고민된다면<br /><Highlight>절반가격</Highlight>에 <HighlightCost>한 달 간</HighlightCost><br />사용 후 결정하세요!</h2>
            </PromotionLeft>
            <PromotionRight className="promotion-right">
              <div className="promotion-banner">
                <img src={sale} alt="50% SALE" className="sale-image" />
              </div>
            </PromotionRight>
          </PromotionContent>
        </Container>
      </PromotionSection>

      <MediaSection ref={mediaSectionRef}>
        <MediaContent>
          <MediaText className="media-text">
            <p className="media-subtitle">오늘의 잔반이 내일의 씨앗이 될 수 있도록</p>
            <h2>맛있게 <Highlight>식사</Highlight>하세요.</h2>
            <h2>그 뒤는 <HighlightCost>저희가 노력하겠습니다.</HighlightCost></h2>
          </MediaText>
        </MediaContent>
      </MediaSection>

      <FinalCTASection ref={finalCTASectionRef} id="contact">
        <Container>
          <FinalCTAContent>
            <FinalCTALeft className="final-cta-left">
              <h2><HighlightCost>쓸모</HighlightCost>를 사용중인 고객은<br />이미 <Highlight>비용을 절감</Highlight>하고 있습니다.</h2>
              <p>이제는 <HighlightCost>'쓸모'</HighlightCost>하세요!</p>
            </FinalCTALeft>
            <FinalCTARight>
              <form className="simple-contact-form" onSubmit={handleSubmit}>
                <div className="form-field">
                  <label htmlFor="name">이름</label>
                  <input type="text" id="name" name="name" placeholder="홍길동" required />
                </div>
                <div className="form-field">
                  <label htmlFor="email">메일 주소</label>
                  <input type="email" id="email" name="email" placeholder="you@example.com" required />
                </div>
                <div className="form-field">
                  <label htmlFor="company">회사명</label>
                  <input type="text" id="company" name="company" placeholder="(주)쓸모" required />
                </div>
                <div className="form-field">
                  <label htmlFor="phone">연락처</label>
                  <input type="tel" id="phone" name="phone" placeholder="010-0000-0000" required />
                </div>
                <div className="form-field">
                  <label htmlFor="title">직책</label>
                  <input type="text" id="title" name="title" placeholder="매니저" required />
                </div>
                <div className="form-field full-width">
                  <label htmlFor="message">문의 내용</label>
                  <textarea id="message" name="message" rows={5} placeholder="도입 배경/요청 사항 등을 적어주세요." required />
                </div>
                <button type="submit" className="submit-btn" style={{ width: '100%' }}>제출하기</button>
              </form>
            </FinalCTARight>
          </FinalCTAContent>
        </Container>
      </FinalCTASection>
      <ContactModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} initialSource="hero_top_cta" />
    </main>
  );
};

export default Home;